import {
    chain,
    update,
    set,
} from 'immutadot'

import {
    ROTATE_LEFT,
    ROTATE_RIGHT,
    LOCK,
    RESET,
    CONTRAST,
    BRIGHTNESS,
    INVERT,
    ZOOM,
    ZOOM_IN,
    ZOOM_OUT,
} from './actions'

import {
    JUMP_TO_MEDIA,
    PREVIOUS_MEDIA,
    NEXT_MEDIA,
    JUMP_TO_GROUP,
    PREVIOUS_GROUP,
    NEXT_GROUP,
    FIRST_MEDIA,
    LAST_MEDIA,
    FORWARD_MEDIA,
    BACKWARD_MEDIA,
} from '../navigation/actions'

export const DEFAULT_ROTATE = 0
export const DEFAULT_SCALE = 1
export const DEFAULT_LOCKED = false
export const DEFAULT_CONTRAST = 0
export const DEFAULT_BRIGHTNESS = 0
export const DEFAULT_INVERT = false
export const DEFAULT_SCALE_STEP = 0.2
export const HIGH_ZOOM_SCALE_STEP = 0.6
export const HIGH_ZOOM_THRESHOLD = 3.5
export const LIMIT_SCALE = 20

const initialState = {
    rotate: DEFAULT_ROTATE,
    scale: DEFAULT_SCALE,
    scaleStep: DEFAULT_SCALE_STEP,
    locked: DEFAULT_LOCKED,
    contrast: DEFAULT_CONTRAST,
    brightness: DEFAULT_BRIGHTNESS,
    invert: DEFAULT_INVERT,
}

export const appliedFilters = (state = initialState, action) => {
    switch (action.type)
    {
        case JUMP_TO_MEDIA:
        case PREVIOUS_MEDIA:
        case NEXT_MEDIA:
        case JUMP_TO_GROUP:
        case PREVIOUS_GROUP:
        case NEXT_GROUP:
        case FORWARD_MEDIA:
        case BACKWARD_MEDIA:
        case LAST_MEDIA:
        case FIRST_MEDIA:
            if(state.locked === true)
            {
                return state
            }

            return chain(state)
                .set('rotate', DEFAULT_ROTATE)
                .set('scale', DEFAULT_SCALE)
                .set('scaleStep', DEFAULT_SCALE_STEP)
                .set('contrast', DEFAULT_CONTRAST)
                .set('brightness', DEFAULT_BRIGHTNESS)
                .set('invert', DEFAULT_INVERT)
                .value()
        case ROTATE_LEFT:
            return update(state, 'rotate', rotate => Number(rotate) - 90)
        case ROTATE_RIGHT:
            return update(state, 'rotate', rotate => Number(rotate) + 90)
        case LOCK:
            return set(state, 'locked', !state.locked)
        case RESET:
            return {...initialState}
        case CONTRAST:
            return set(state, 'contrast', action.contrastLevel)
        case BRIGHTNESS:
            return set(state, 'brightness', action.brightnessLevel)
        case INVERT:
            return set(state, 'invert', ! state.invert)
        case ZOOM:
            const newScale = action.scale
            if(action.scale > LIMIT_SCALE || action.scale < DEFAULT_SCALE)
            {
                return state
            }

            return updateScale(state, newScale)
        case ZOOM_IN:
            const newScaleIn = precisionScale(state.scale + state.scaleStep)
            if(newScaleIn > LIMIT_SCALE)
            {
                return state
            }

            return updateScale(state, newScaleIn)
        case ZOOM_OUT:
            const newScaleOut = precisionScale(state.scale - state.scaleStep)
            if(newScaleOut < DEFAULT_SCALE)
            {
                return state
            }

            return updateScale(state, newScaleOut)
        default:
            return state
    }
}

function precisionScale(scale)
{
    return Number.parseFloat(Number.parseFloat(scale).toFixed(1))
}

function updateScale(state, newScale)
{
    return chain(state)
        .set('scale', newScale)
        .set('scaleStep', newScale > HIGH_ZOOM_THRESHOLD ? HIGH_ZOOM_SCALE_STEP : DEFAULT_SCALE_STEP)
        .value()
}
